"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderPlainResults = void 0;
var orderStrategy_1 = require("./orderStrategy");
var isValidResult = function (result) {
    if (result && typeof result === "object") {
        return result;
    }
    return null;
};
var findValue = function (result, path) {
    var properties = path.split(".");
    return properties.reduce(function (item, property) {
        var validItem = isValidResult(item);
        return !validItem ? validItem : validItem[property];
    }, result);
};
var handleComparison = function (appliedOrderValues, elementA, elementB) {
    var valueA = findValue(isValidResult(elementA), appliedOrderValues.path);
    var valueB = findValue(isValidResult(elementB), appliedOrderValues.path);
    var validType = appliedOrderValues.type;
    var orderStrategy = orderStrategy_1.orderStrategies[validType];
    if (valueA && valueB) {
        return orderStrategy(valueA, valueB);
    }
    return 0;
};
function orderPlainResults(results, appliedOrderValues) {
    return results.sort(function (a, b) { return handleComparison(appliedOrderValues, a, b); });
}
exports.orderPlainResults = orderPlainResults;
//# sourceMappingURL=orderPlainResults.js.map